import { get } from '../httpClient';

export const intercomAPI = {
  verification: {
    generateHash: params => get('/api/intercom/generate-hash', params),
  },
};